export default "__VITE_ASSET__Bg2$1rz9__"